import React from 'react';

// https://github.com/facebook/react/issues/3386#issuecomment-291152357
const HighlightWord = ({ text, query = '', icon }) => {
    if (!text) {
        return;
    }
    if (!query) {
        return (
            <span>
                {icon && icon}
                {text}
            </span>
        );
    }
    return (
        <span className="font-weight-bold">
            {icon && icon}
            {text.split(query).reduce((prev, current, i) => {
                if (!i) {
                    return [current];
                }
                return prev.concat(
                    <span className={`font-weight-normal`} key={i}>
                        {query}
                    </span>,
                    current
                );
            }, [])}
        </span>
    );
};

export default HighlightWord;
